module.exports = BVServices.bodyScrollManager;